import React, { Component } from "react";
import { main_url } from "../../../utils/CommonFunction";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import Select from "react-select";
import DatePicker from "react-datetime";
import moment from "moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { unstable_composeClasses } from "@mui/material";
import { getHeaders } from "../../../utils/apiHelper";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");
class PayrollSummaryReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regionList: null,
      empName: 0,
      martial_status: null,
      contact_person: null,
      contact_phone: null,
      guarantee_contact_person: null,
      guarantee_contact_phone: null,
      phone_no: null,
      employee_id: null,
      employee_date: moment().format("YYYY-MM-DD"),
      selected_Branch: null,
      selected_department: null,
      selected_designation: null,
      selected_region: null,
      designationList: null,
      branchlist: null,
      departmentlist: null,
      branchId: null,
      designationId: null,
      departmentId: null,
      regionId: null,
      EmployeeNameList: null,
      selected_employee: null,
      date: moment().format("YYYY-MM"),
      dataSource: [],
      PayrollList: [],
      ReportHeader: [],
      ReportDetails:[],
      AtmCash:[]
    };
  }

  async componentDidMount() {
    this.$el = $(this.el);
    this.setState(
      {
        dataSource: this.props.data,
      },
      () => {}
    );
    this.getRegionList();
    this.getBranchList();
    this.handleSearchData();
    this.getpayRoll();
    // this.getPayrollReportHeader();
    // this.PayrollSummaryReportATMorCash();
    // this.PayrollSummaryReportDetails();
  }

  getBranchList() {
    fetch(`${main_url}benefit/getBranchList`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ value: 0, label: "All" });
        this.setState({
          branchlist: list.map((v) => ({
            ...v,
          })),
        });
      });
  }
  getPayrollReportHeader() {
    // fetch(
    //   `${main_url}payroll_report/getPayrollReportHeader/` +
    //     moment(this.state.data).format("YYYY-MM")
    // )
    fetch(`${main_url}payroll_report/getPayrollReportHeader/`+moment(this.state.date).format('YYYY-MM'), {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        this.setState({
          ReportHeader: list,
        });
      });
  }

  getRegionList() {
    fetch(`${main_url}benefit/getRegionList`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ state_id: 0, state_name: "All" });
        this.setState({
          regionList: list.map((v) => ({
            ...v,
            label: v.state_name,
            value: v.state_id,
          })),
        });
      });
  }

  handleSelectedBranch = async (event) => {
    if (event != null)
      this.setState({
        selected_Branch: event,
      });
  };
  PayrollSummaryReportDetails=async ()=>{
    const branchId = this.state.selected_Branch
      ? this.state.selected_Branch.value
      : 0;

    const regionId = this.state.selected_region
      ? this.state.selected_region.state_id
      : 0;
    const Date = moment(this.state.date).format("YYYY-MM");
    fetch(main_url + "payroll_report/payrollSummaryReportDetails/"+Date+'/'+regionId+'/'+branchId, {
      headers: getHeaders(),
    })
    .then((res) => {
      if (res.ok) return res.json();
    })
    .then((list) => {
      
      this.setState({
        ReportDetails:list,
      });
    });
  }
  PayrollSummaryReportATMorCash=async()=>{
    const branchId = this.state.selected_Branch
    ? this.state.selected_Branch.value
    : 0;

  const regionId = this.state.selected_region
    ? this.state.selected_region.state_id
    : 0;
  const Date = moment(this.state.date).format("YYYY-MM");
  fetch(main_url + "payroll_report/payrollSummaryReportAtmCash/"+Date+'/'+regionId+'/'+branchId, {
    headers: getHeaders(),
  })
  .then((res) => {
    if (res.ok) return res.json();
  })
  .then((list) => {
    
    this.setState({
      AtmCash:list,
    });
  });
  }

  handleSelectedRegion = async (event) => {
    if (event != null)
      this.setState({
        selected_region: event,
      });
  };
  handleSelectedDate = async (event) => {
    this.setState({
      date: event,
    });
  };
  getpayRoll = () => {
    fetch(main_url + "payroll/getPayroll", {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let data = list.filter((v) => v.check == 1);
        this.setState({
          PayrollList: data,
        });
      });
  };

  handleSearchData = async () => {
    // this.setState({
    const branchId = this.state.selected_Branch
      ? this.state.selected_Branch.value
      : 0;

    const regionId = this.state.selected_region
      ? this.state.selected_region.state_id
      : 0;
    const Date = moment(this.state.date).format("YYYY-MM");

    // })

    await fetch(main_url + "payroll_report/payrollSummaryReport/"+Date+'/'+regionId+'/'+branchId, {
        headers: getHeaders(),
      })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        // let uniqueDeductiondata=new Set();
        // list.forEach(v=>{
        //   v.deduction.forEach(v1=>{
        //     uniqueDeductiondata.add(v1.salary_payment_deduction_label)
        //   })
        // })
        // console.log("unique data",uniqueDeductiondata)
        // let uniqueDeductionMap=new Map();
        // uniqueDeductiondata.forEach(v=>{
        //   uniqueDeductionMap.set({
        //     'salary_payment_deduction_label':v,
        //     'salary_payment_deduction_value':0
        //   })
        // })
        // console.log("unique map",)
        this.setState({
          dataSource: list,
        });
      });
      await this.getPayrollReportHeader();
      await this.PayrollSummaryReportATMorCash();
      await this.PayrollSummaryReportDetails();

  };
  render() { 
    let filterData =
      this.state.ReportHeader &&
      this.state.ReportHeader.filter(
        (v) => v.label != "Income Tax" && v.label != "SSC"
      );
      // let atmCount= 
      // this.state.dataSource != undefined && this.state.dataSource.length > 0
      // ? this.state.dataSource.filter(v=>v.state_id == 3).length : 0; console.log('22222222222222',atmCount);
      let finalDatasource =
      this.state.dataSource != undefined && this.state.dataSource.length > 0
        ? this.state.dataSource
        : [];
    let FinalAtmCash=this.state.AtmCash != undefined && this.state.AtmCash.length > 0 ? this.state.AtmCash : []
    let FinalReportDetails=this.state.ReportDetails != undefined && this.state.ReportDetails.length > 0 ? this.state.ReportDetails : []

    let AtmTotal=FinalAtmCash.filter(v=>v.payment_type == '1') && FinalAtmCash.filter(v=>v.payment_type == '1')[0];
    let CashTotal=FinalAtmCash.filter(v=>v.payment_type == '2') && FinalAtmCash.filter(v=>v.payment_type == '2')[0];
    let SavingTotal=FinalAtmCash.filter(v=>v.payment_type == '3') && FinalAtmCash.filter(v=>v.payment_type == '3')[0];
    
    let AtmAmount =AtmTotal != undefined ? AtmTotal.total_amount : '-';
    let CashAmount =CashTotal != undefined ? CashTotal.total_amount : '-';
    let SavingAmount =SavingTotal != undefined ? SavingTotal.total_amount : '-';
    let Total=(typeof(AtmAmount) == 'number' ?  AtmAmount : 0)+(typeof(CashAmount)=='number' ?  CashAmount : 0)+(typeof(SavingAmount)=='number' ?  SavingAmount : 0);

    let filterIncomeTax = finalDatasource.map(
      (d) =>
        d.deduction.length > 0 &&
        d.deduction.filter(
          (v) => v.salary_payment_deduction_label == "Income Tax"
        )
    );
    // console.log(
    //   "incometax",
    //   filterIncomeTax.filter((d) => (d.length > 0 ? d[0] : 0))
    // );
    let NextFilterIncomeTax = filterIncomeTax.filter((d) =>
      d.length > 0 ? d[0] : 0
    );
    // console.log("next filter incometax",NextFilterIncomeTax)
    let FilterDeduction = finalDatasource.filter((v) => v.deduction.length > 0);
    console.log('filter Deduction',FilterDeduction)
    let FilterAddition=finalDatasource.filter((v)=>v.addition.length > 0);
    let Deduction = [];
    let Addition=[]
    FilterDeduction.map((v) => {
      filterData.map((header) => {
        if (
          v.deduction.filter(
            (d) => d.salary_payment_deduction_label == header.label
          ).length > 0
        ) {
          Deduction.push(
            v.deduction.filter(
              (d) => d.salary_payment_deduction_label == header.label
            )[0]
          );
        }
        // Deduction.push(v.deduction.filter(d=>d.salary_payment_deduction_label == header.label).length > 0 && v.deduction.filter(d=>d.salary_payment_deduction_label == header.label)[0])
      });
    });
    FilterAddition.map((v) => {
      filterData.map((header) => {
        if (
          v.addition.filter(
            (d) => d.salary_payment_allowance_label == header.label
          ).length > 0
        ) {
          Addition.push(
            v.addition.filter(
              (d) => d.salary_payment_allowance_label == header.label
            )[0]
          );
        }
        // Deduction.push(v.deduction.filter(d=>d.salary_payment_deduction_label == header.label).length > 0 && v.deduction.filter(d=>d.salary_payment_deduction_label == header.label)[0])
      });
    });
    
    let totalDeductionData = Deduction.reduce((r, c) => {
      let R = [...r];
      const index = R.findIndex(
        (v) =>
          v.salary_payment_deduction_label == c.salary_payment_deduction_label
      );
      if (index == -1) {
        R.push({
          salary_payment_deduction_label: c.salary_payment_deduction_label,
          value: c.salary_payment_deduction_value,
        });
      } else {
        R[index].value += c.salary_payment_deduction_value;
      }
      return R;
    }, []);
    let totalAdditionData = Addition.reduce((r, c) => {
      let R = [...r];
      const index = R.findIndex(
        (v) =>
          v.salary_payment_allowance_label == c.salary_payment_allowance_label
      );
      if (index == -1) {
        R.push({
          salary_payment_allowance_label: c.salary_payment_allowance_label,
          value: c.salary_payment_allowance_value,
        });
      } else {
        R[index].value += c.salary_payment_allowance_value;
      }
      return R;
    }, []);
   
    // console.log("income tax total",NextFilterIncomeTax.length > 0 && NextFilterIncomeTax.reduce((p,c)=>{return p+c[0].salary_payment_deduction_value},0))
    return (
      <div style={{ overflowX: "auto" }}>
        <div className="row dashboard-header">
         
          <h3 className="">
            Payroll Summary Report
          </h3>
          
         <div className="row" style={{marginBottom:10}}>
          <div className="col-md-12" style={{marginBottom:10}}>
          <div
            className="flex-row"
            style={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
             
            }}
          >
            <DatePicker
              dateFormat="YYYY-MM"
              value={this.state.date}
              onChange={this.handleSelectedDate}
              timeFormat={false}
            />
            <Select
              styles={{
                container: (base) => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                  marginRight: 10,
                  marginLeft: 10,
                }),
                control: (base) => ({
                  ...base,
                  minHeight: "18px",
                }),
              }}
              placeholder="Branch"
              options={this.state.branchlist}
              onChange={this.handleSelectedBranch}
              value={this.state.selected_Branch}
              className="react-select-container"
              classNamePrefix="react-select"
            />
            <Select
              styles={{
                container: (base) => ({
                  ...base,
                  //   flex: 1
                  width: 150,
                }),
                control: (base) => ({
                  ...base,
                  minHeight: "18px",
                }),
              }}
              placeholder="Region"
              options={this.state.regionList}
              onChange={this.handleSelectedRegion}
              value={this.state.selected_region}
              className="react-select-container"
              classNamePrefix="react-select"
            />

            <button
              className="btn btn-primary text-center"
              style={{ marginLeft: 10, height: 30, padding: "0px 5px 0px 5px" }}
              onClick={() => this.handleSearchData()}
            >
              Search
            </button>
          </div>
          </div>
          <div className="col-md-12 btn-leftend">
          <ReactHTMLTableToExcel 
                    className="btn-excel"
                    table="payroll_summary_report"
                    filename={"Payroll Summary Report"+moment(this.state.date).format('YYYY-MM')}
                    buttonText="Excel"
                    sheet="Sheet"
                    />
          </div>
         
         
         </div>
          
          <table id='payroll_summary_report'>
          <table
            className="table table-bordered"
            style={{ overflow: "scroll" }}
            
          >
            <thead>
              <tr style={{ overflow: "scroll",textAlign:'center' }}>
                <th rowSpan={2} style={{verticalAlign:'middle',textAlign:'center'}}>
                  No
                </th>
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Region</th>
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Branch Name</th>
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Gross salary</th>
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Deductions(+)/Additions(-)</th>
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Salary after deductions/additions</th>
                <th colSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>SSC</th>
                {this.state.ReportHeader &&
                this.state.ReportHeader.filter(
                  (v) => v.label == "Income Tax"
                ) ? (
                  <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Income Tax</th>
                ) : (
                  ""
                )}
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Net Salary Paid</th>
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Total Gross Salary</th>
                {
                  totalDeductionData.length > 0 && totalDeductionData.map(v=>{
                    return(
                      <th rowSpan={2} style={{verticalAlign:'middle',textAlign:'center'}}>{v.salary_payment_deduction_label}</th>
                    )
                  })
                }
                {
                  totalAdditionData.length > 0 && totalAdditionData.map(v=>{
                    return(
                      <th rowSpan={2} style={{verticalAlign:'middle',textAlign:'center'}}>{v.salary_payment_allowance_label}</th>
                    )
                  })
                }

                {/* {filterData &&
                  filterData.map((v) => {
                    return <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>{v.label}</th>;
                  })} */}
                <th rowSpan={2} style={{textAlign:'center',verticalAlign:'middle'}}>Total</th>
              </tr>
              <tr>
                <th style={{verticalAlign:'middle',textAlign:'center'}}>Employer 3%</th>
                <th style={{verticalAlign:'middle',textAlign:'center'}}>Employee 2%</th>
              </tr>
            </thead>
            <tbody>
              {finalDatasource.length > 0 &&
                finalDatasource.map((v, i) => {
                  return (
                    <tr>
                      <td style={{textAlign:'center'}}>{i + 1}</td>
                      <td style={{textAlign:'center'}}>{v.state_name}</td>
                      <td style={{textAlign:'center'}}>{v.location_master_name}</td>
                      <td style={{textAlign:'center'}}>{v.gross_salary}</td>
                      <td style={{textAlign:'center'}}>{v.deduction_addition_data}</td>
                      <td style={{textAlign:'center'}}>{v.after_deduction_or_addition}</td>
                      <td style={{textAlign:'center'}}>
                        {v.ssc.length > 0 && v.ssc[0] && v.ssc[0].Employee_3}
                      </td>
                      <td style={{textAlign:'center'}}>
                        {v.ssc.length > 0 && v.ssc[0] && v.ssc[0].Employer_2}
                      </td>
                      {v.deduction.length > 0 ? (
                        v.deduction.filter(
                          (v1) =>
                            v1.salary_payment_deduction_label == "Income Tax"
                        ).length > 0 ? (
                          <td style={{textAlign:'center'}}>
                            {
                              v.deduction.filter(
                                (v1) =>
                                  v1.salary_payment_deduction_label ==
                                  "Income Tax"
                              )[0].salary_payment_deduction_value
                            }
                          </td>
                        ) : (
                          <td style={{textAlign:'center'}}>0</td>
                        )
                      ) : (
                        <td style={{textAlign:'center'}}>0</td>
                      )}
                      <td style={{textAlign:'center'}}>{v.net_salary}</td>
                      <td style={{textAlign:'center'}}>{v.total_gross_salary}</td>
                      {totalDeductionData.map((a, i) => {
                        return (
                          <td style={{textAlign:'center'}}>
                            {v.deduction.length > 0 &&
                            v.deduction.filter(
                              (d) => d.salary_payment_deduction_label == a.salary_payment_deduction_label
                            ).length > 0
                              ? v.deduction.filter(
                                  (d) =>
                                    d.salary_payment_deduction_label == a.salary_payment_deduction_label
                                )[0].salary_payment_deduction_value
                              : 0}
                          </td>
                        );
                      })}
                      {/* {totalAdditionData.map((a, i) => {
                        return (
                          <>
                            {v.addition.length > 0 &&
                            v.addition.filter(
                              (d) => d.salary_payment_allowance_label == a.salary_payment_allowance_label
                            ).length > 0 ? (
                              <td style={{textAlign:'center'}}>
                                {
                                  v.addition.filter(
                                    (d) =>
                                      d.salary_payment_allowance_label == a.salary_payment_allowance_label
                                  )[0].salary_payment_allowance_value
                                }
                              </td>
                            ) : (
                              ""
                            )}
                          </>
                        );
                      })} */}
                      {totalAdditionData.map((a, i) => {
                        return (
                          <td style={{textAlign:'center'}}>
                            {v.addition.length > 0 &&
                            v.addition.filter(
                              (d) => d.salary_payment_allowance_label == a.salary_payment_allowance_label
                            ).length > 0
                              ? v.addition.filter(
                                  (d) =>
                                    d.salary_payment_allowance_label == a.salary_payment_allowance_label
                                )[0].salary_payment_allowance_value
                              : 0}
                          </td>
                        );
                      })}
                      <td style={{textAlign:'center'}}>{v.total}</td>
                    </tr>
                  );
                })}

              
              {
                  FinalReportDetails.map(v=>{
                    return(
                      <tr>
                        <td colSpan={3} style={{textAlign:'center',fontWeight:'bold'}}>{v.name}</td>
                        <td style={{textAlign:'center',fontWeight:'bold'}}>{v.gross_salary}</td>
                        <td style={{textAlign:'center',fontWeight:'bold'}}>{v.deduction_addition_data}</td>
                        <td style={{textAlign:'center',fontWeight:'bold'}}>{v.after_deduction_or_addition}</td>
                        <td style={{textAlign:'center',fontWeight:'bold'}}>{v.ssc.length > 0 && v.ssc[0].Employee_3}</td>
                        <td style={{textAlign:'center',fontWeight:'bold'}}>{v.ssc.length > 0 && v.ssc[0].Employer_2}</td>
                        {v.deduction.length > 0 ? (
                        v.deduction.filter(
                          (v1) =>
                            v1.salary_payment_deduction_label == "Income Tax"
                        ).length > 0 ? (
                          <td style={{textAlign:'center',fontWeight:'bold'}}>
                            {
                              v.deduction.filter(
                                (v1) =>
                                  v1.salary_payment_deduction_label ==
                                  "Income Tax"
                              )[0].salary_payment_deduction_value
                            }
                          </td>
                        ) : (
                          <td style={{textAlign:'center',fontWeight:'bold'}}>0</td>
                        )
                      ) : (
                        <td style={{textAlign:'center',fontWeight:'bold'}}>0</td>
                      )}
                        <td style={{textAlign:'center',fontWeight:'bold'}}>{v.net_salary}</td>
                      <td style={{textAlign:'center',fontWeight:'bold'}}>{v.total_gross_salary}</td>
                      {totalDeductionData.map((a, i) => {
                        return (
                          <td style={{textAlign:'center',fontWeight:'bold'}}>
                            {v.deduction.length > 0 &&
                            v.deduction.filter(
                              (d) => d.salary_payment_deduction_label == a.salary_payment_deduction_label
                            ).length > 0
                              ? v.deduction.filter(
                                  (d) =>
                                    d.salary_payment_deduction_label == a.salary_payment_deduction_label
                                )[0].salary_payment_deduction_value
                              : 0}
                          </td>
                        );
                      })}
                       {totalAdditionData.map((a, i) => {
                        return (
                          <td style={{textAlign:'center',fontWeight:'bold'}}>
                            {v.addition.length > 0 &&
                            v.addition.filter(
                              (d) => d.salary_payment_allowance_label == a.salary_payment_allowance_label
                            ).length > 0
                              ? v.addition.filter(
                                  (d) =>
                                    d.salary_payment_allowance_label == a.salary_payment_allowance_label
                                )[0].salary_payment_allowance_value
                              : 0}
                          </td>
                        );
                      })}
                      <td style={{textAlign:'center',fontWeight:'bold'}}>{v.total}</td>
                      </tr>
                    )
                  })
              }
              <tr>
                <td colSpan={3} style={{textAlign:'center',fontWeight:'bold'}}>All Total</td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.gross_salary;
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.deduction_addition_data;
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.after_deduction_or_addition;
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p +c.ssc[0].Employee_3
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.ssc[0].Employer_2
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {NextFilterIncomeTax.reduce((p, c) => {
                    return p + c[0].salary_payment_deduction_value;
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.net_salary;
                  }, 0)}
                </td>
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.total_gross_salary;
                  }, 0)}
                </td>
                {
                  totalDeductionData.map(v=>{
                    return (
                      <td style={{textAlign:'center',fontWeight:'bold'}}>{v.value}</td>
                    )
                  })
                }
                {
                  totalAdditionData.map(v=>{
                    return (
                      <td style={{textAlign:'center',fontWeight:'bold'}}>{v.value}</td>
                    )
                  })
                }
                <td style={{textAlign:'center',fontWeight:'bold'}}>
                  {finalDatasource.reduce((p, c) => {
                    return p + c.total;
                  }, 0)}
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <table className="table table-bordered" id="payroll_summary_report" style={{ width: "20%" }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ATM</td>
                  <td>{AtmAmount}</td>
                </tr>
                <tr>
                  <td>Cash</td>
                  <td>{CashAmount}</td>
                </tr>
                <tr>
                  <td>Saving</td>
                  <td>{SavingAmount}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td>{Total}</td>
                </tr>
              </tbody>
            </table>
          </div>
          </table>
        </div>
      </div>
    );
  }
}
export default PayrollSummaryReport;
